<template>
  <div class="summary-section">
    <div class="summary-section-header sc-header">Certification Details</div>
    <div class="summary-section-content">
      <div class="sc-table-details"></div>
      <table>
        <tr v-for="field in data" :key="field.name">
          <th class="xname sc-label">{{ field.label || "" }}</th>
          <td class="xtext sc-value">{{ field.value || "" }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { CertificationDetails } from "@/types/certifications";

const props = defineProps<{ certificationDetails?: CertificationDetails }>();

const data = ref([
  {
    name: "referenceId",
    label: "Ref Id",
    title: "Reference Id",
    value: props.certificationDetails?.referenceId,
  },
  {
    name: "certificationCreatedDate",
    label: "Cert Created Date",
    title: "Certification Created Date",
    value: props.certificationDetails?.createdDate,
  },
  {
    name: "certificationExpirationDate",
    label: "Cert Exp. Date",
    title: "Certification Expiration Date",
    value: props.certificationDetails?.expirationDate,
  },
]);
</script>

<style scoped src="@/assets/css/certifications-and-disbursements.css"></style>
